import { isFrictionlessSignupUser } from '@frontend/api-client';
import type { Client } from '@frontend/api-types';
import { FIRST_TASK_FAST_TRACK_DEFAULT, useFeatureValue } from '@frontend/react';
import { usePromoSlice } from '@frontend/redux';

export const useShouldRedirectToFirstTask = (
  client: MaybeUndefined<Client>,
  overridePromotionId?: string | null,
): boolean => {
  const { value: config } = useFeatureValue('first_task_fast_track', FIRST_TASK_FAST_TRACK_DEFAULT);
  const { state } = usePromoSlice();
  const promoDetails = state?.promoDetails;

  if (isFrictionlessSignupUser(client)) {
    return false;
  }

  if (config.mode === 'none') {
    return false;
  }
  if (config.mode === 'all') {
    return true;
  }
  if (config.mode === 'promotion') {
    const appliedId = overridePromotionId ?? promoDetails?.promotionId;
    const ids = config.promotion_ids ?? [];
    return Boolean(appliedId && ids.length > 0 && ids.includes(appliedId));
  }
  return false;
};
